import './init';
import firebase from 'firebase/app';
import 'firebase/firestore';
const db = firebase.firestore;
export default db();
export const { FieldValue, Timestamp, FieldPath } = db;
